"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGetRequest$ = exports.GetCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGetRequest$outboundSchema = exports.GetCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGetRequest$inboundSchema = exports.GetCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGetSecurity$ = exports.GetCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGetSecurity$outboundSchema = exports.GetCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGetSecurity$inboundSchema = void 0;
exports.getCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGetSecurityToJSON = getCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGetSecurityToJSON;
exports.getCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGetSecurityFromJSON = getCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGetSecurityFromJSON;
exports.getCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGetRequestToJSON = getCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGetRequestToJSON;
exports.getCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGetRequestFromJSON = getCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGetRequestFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.GetCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGetSecurity$inboundSchema = z.object({
    Bearer: z.string().optional(),
    "X-API-KEY": z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "Bearer": "bearer",
        "X-API-KEY": "xApiKey",
    });
});
/** @internal */
exports.GetCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGetSecurity$outboundSchema = z.object({
    bearer: z.string().optional(),
    xApiKey: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        bearer: "Bearer",
        xApiKey: "X-API-KEY",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGetSecurity$;
(function (GetCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGetSecurity$) {
    /** @deprecated use `GetCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGetSecurity$inboundSchema` instead. */
    GetCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGetSecurity$.inboundSchema = exports.GetCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGetSecurity$inboundSchema;
    /** @deprecated use `GetCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGetSecurity$outboundSchema` instead. */
    GetCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGetSecurity$.outboundSchema = exports.GetCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGetSecurity$outboundSchema;
})(GetCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGetSecurity$ || (exports.GetCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGetSecurity$ = GetCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGetSecurity$ = {}));
function getCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGetSecurityToJSON(getCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGetSecurity) {
    return JSON.stringify(exports.GetCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGetSecurity$outboundSchema
        .parse(getCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGetSecurity));
}
function getCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGetSecurityFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGetSecurity$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'GetCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGetSecurity' from JSON`);
}
/** @internal */
exports.GetCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGetRequest$inboundSchema = z.object({
    local_authority_code: z.string(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "local_authority_code": "localAuthorityCode",
    });
});
/** @internal */
exports.GetCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGetRequest$outboundSchema = z.object({
    localAuthorityCode: z.string(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        localAuthorityCode: "local_authority_code",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGetRequest$;
(function (GetCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGetRequest$) {
    /** @deprecated use `GetCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGetRequest$inboundSchema` instead. */
    GetCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGetRequest$.inboundSchema = exports.GetCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGetRequest$inboundSchema;
    /** @deprecated use `GetCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGetRequest$outboundSchema` instead. */
    GetCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGetRequest$.outboundSchema = exports.GetCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGetRequest$outboundSchema;
})(GetCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGetRequest$ || (exports.GetCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGetRequest$ = GetCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGetRequest$ = {}));
function getCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGetRequestToJSON(getCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGetRequest) {
    return JSON.stringify(exports.GetCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGetRequest$outboundSchema
        .parse(getCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGetRequest));
}
function getCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGetRequestFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGetRequest$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'GetCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGetRequest' from JSON`);
}
//# sourceMappingURL=getcrimebylocalauthoritystatscrimecrimebylocalauthoritylocalauthoritycodeget.js.map